// changed map keys
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const SatisfactionGuaranteed = ({ data = [] }) => {
  return (
    <section className="section satisfaction-guaranteed">
      <Container>
        <Row>
          <Col xl={8} lg={10} xs={12} className="mx-auto">
            <div className="text-center mb-5 pb-2">
              {/* <img src={data.satisfaction_icons} width="50px" alt="Satisfaction Guaranteed" /> */}
              <h2 className="mb-2">{data.satisfaction_title}</h2>
              <p className="mb-4 pb-2 text-xxl">{data.satisfaction_description}</p>
              <Link to="/select-insurance" className="btn btn-primary mb-4">
                {data.satisfaction_button_title}{" "}
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className="satisfaction-slider d-flex justify-content-center">
              {data.satisfaction_slider
                ? data.satisfaction_slider.map((imgSrc) => {
                    return (
                      <div key={imgSrc?.image}>
                        <img className="img-fluid" src={imgSrc.image} alt="slider" />
                      </div>
                    );
                  })
                : null}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SatisfactionGuaranteed;
